import { NgModule } from '@angular/core';

import { MasterAccessProfileActions } from './master-access-profile.actions';
import { AnteriorAction } from './master-anterior-access-profile.action';
import { ProximoAction } from './master-proximo-access-profile.action';

@NgModule({
  providers: [
      AnteriorAction,
      ProximoAction,
    MasterAccessProfileActions
  ]
})
export class MasterAccessProfileActionsModule {}
